import * as React from 'react';
import { Box, IconButton } from '@mui/material';

export interface CardAction {
  key: string;
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  destructive?: boolean;
}

interface CardActionIconsProps {
  /* falsy entries are ignored, so callers can inline role checks */
  actions: (CardAction | false | null | undefined)[];
}

/**
 * Wiersz ikon akcji rekordu, renderowany wprost na karcie listy mobilnej.
 *
 * Zastapil kebab + bottom sheet: przy dwoch-trzech akcjach szuflada kosztowala
 * dodatkowe tapniecie i zaslaniala liste, nie dajac nic w zamian. Ikony sa
 * widoczne od razu, wiec `label` zostaje tylko jako `aria-label` — Tooltipa nie
 * ma celowo, te karty renderuja sie wylacznie ponizej 600px, gdzie hover nie
 * istnieje, a MUI pokazalby go dopiero po dlugim przytrzymaniu.
 */
export const CardActionIcons = ({ actions }: CardActionIconsProps) => {
  const visibleActions = actions.filter(Boolean) as CardAction[];

  if (!visibleActions.length) return null;

  return (
    /* Bez `gap`: motyw wymusza 44x44 na kazdym IconButtonie przy `pointer: coarse`,
       wiec ikony i tak dzieli ~24px wlasnego paddingu. Dodatkowa przerwa zabierala
       tylko szerokosc nazwie rekordu obok, ktora przy trzech akcjach jest w cenie. */
    <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
      {visibleActions.map((action) => (
        <IconButton
          key={action.key}
          size="small"
          aria-label={action.label}
          onClick={action.onClick}
          sx={{
            borderRadius: 'var(--radius-md)',
            color: action.destructive ? 'var(--color-error)' : 'var(--color-primary)',
            '&:hover': {
              backgroundColor: action.destructive
                ? 'var(--color-error-soft)'
                : 'var(--color-primary-soft)',
            },
          }}
        >
          {action.icon}
        </IconButton>
      ))}
    </Box>
  );
};

export default CardActionIcons;
